import { ClassRating } from "constants/rate-classes";
import { IPendingClassRating } from "hooks/use-rate-class/use-rate-class.types";

export interface IPendingFeedbackAPIResponse {
  data?: {
    feedbacks: Feedback[];
    partial_feedbacks: PartialFeedback[];
    meta: Meta;
    media_base_url: string;
  };
}

export interface IRestructuredPendingFeedbacksAPIResponse {
  feedbacks: IPendingClassRating[];
  metaData: {
    ratings: {
      rating_id: string;
      rating: ClassRating;
    }[];
    tagsByRating: Record<string, Tag[]>;
  };
}

export enum PendingClassRatingStatus {
  NEW = "new",
  SKIPPED = "skipped",
  DISMISSED = "dismissed",
  COMPLETED = "completed"
}

export interface Feedback {
  id: string;
  actor_list: string[];
  entity_id: string;
}

export interface Meta {
  actors: Actor[];
  entities: Entity[];
  tags: Tag[];
  assets: Asset[];
}

export enum ActorType {
  SUBJECT = "subject",
  TEACHER = "teacher"
}

export interface Actor {
  id: string;
  name: string;
  type: ActorType;
}

export interface Asset {
  id: string;
  png: string;
  svg: string;
}

export interface Entity {
  id: string;
  title: string;
  type: string;
}

export interface Tag {
  id: string;
  title: string;
  rating: ClassRating;
  rating_id: string;
  rating_name: string;
}

export interface PartialFeedback {
  entity_id: string;
  user_feedback_id: string;
  rating: ClassRating;
  status: PendingClassRatingStatus;
}

export interface ISubmitClassFeedbackPayload {
  entity_id: string;
  rating_id?: string;
  rating?: ClassRating;
  status?: PendingClassRatingStatus;
}

export interface ISubmitClassFeedbackResponse {
  user_feedback_id: string;
  entity_id: string;
}

export interface IUpdateClassFeedbackPayload {
  user_feedback_id: string;
  feedback_details: {
    status: PendingClassRatingStatus;
    tags: string[];
    comment: string;
  };
}

export interface IUpdateClassFeedbackResponse {
  user_feedback_id: string;
  entity_id: string;
}
